import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
var NoWallet = function NoWallet() {
  return import('@/components/organisms/NoWallet');
};
var AppFooter = function AppFooter() {
  return import('@/components/organisms/AppFooter');
};
export default {
  components: {
    NoWallet: NoWallet,
    AppFooter: AppFooter
  },
  layout: 'blank',
  props: {
    error: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var walletStore;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(_this.error.cause.statusCode === 4013)) {
              _context.next = 10;
              break;
            }
            _context.next = 3;
            return useAuthStore().signOut();
          case 3:
            _context.next = 5;
            return useWalletStore();
          case 5:
            walletStore = _context.sent;
            _context.next = 8;
            return walletStore.reset();
          case 8:
            alert('Authentication expired. Please sign in again.');
            setTimeout(function () {
              return location.href = '/';
            }, 1000);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};